import { get } from 'svelte/store';
import { yardPriceMarkers, tripCalculationsMarkers } from '../../../stores'


export function clearYardPriceMarkers() {
    let localYardPriceMarkers = get(yardPriceMarkers);

    for (var i = localYardPriceMarkers.length - 1; i >= 0; i--) {
        localYardPriceMarkers[i].marker.remove();
    }
    localYardPriceMarkers = [];
    yardPriceMarkers.update((n) => []);
}

export function clearTripCalculations() {
    let localtripCalculationsMarkers = get(tripCalculationsMarkers);

    for (var i = localtripCalculationsMarkers.length - 1; i >= 0; i--) {
        localtripCalculationsMarkers[i].remove();
    }
    tripCalculationsMarkers.update((n) => []);
}